import { toast } from 'react-toastify';
import { ProgramStudentStatus } from '../../../../../../api/types/programs/students/program-student-status';
import appApi from '../../../../../../api/app-api';
import globalUserPage from '../../../../../../stores/global-user-page';
import { runInAction } from 'mobx';

export const updateStudentStatusInProgramOperation = async (
  branchId: number,
  programId: number,
  studentId: number,
  status: ProgramStudentStatus,
  statusDate: Date | null,
  setLoading: (loading: boolean) => any,
  ohHide: () => any,
) => {
  try {
    if (!status) {
      toast.warn('יש לבחור סטטוס');
      return;
    }

    if (!statusDate) {
      toast.warn('יש לבחור תאריך');
      return;
    }

    setLoading(true);
    await appApi.updateProgramStudentStatus(
      branchId,
      programId,
      studentId,
      status,
      statusDate,
    );

    const studentDetails = globalUserPage.studentDetails;
    if (studentDetails) {
      runInAction(() => {
        // Update in programs array
        const targetProgram = studentDetails.programs.find(
          (item) => item.id === programId && item.branchId === branchId,
        );

        if (targetProgram) {
          targetProgram.studentStatus = {
            ...targetProgram.studentStatus,
            status: status,
            registrationDate:
              status === ProgramStudentStatus.REGISTERED
                ? statusDate
                : targetProgram.studentStatus.registrationDate,
            studyingStartDate:
              status === ProgramStudentStatus.STUDYING
                ? statusDate
                : targetProgram.studentStatus.studyingStartDate,
            cancellationDate:
              status === ProgramStudentStatus.CANCELLED
                ? statusDate
                : targetProgram.studentStatus.cancellationDate,
            leftDate:
              status === ProgramStudentStatus.LEFT
                ? statusDate
                : targetProgram.studentStatus.leftDate,
            completionDate:
              status === ProgramStudentStatus.COMPLETED
                ? statusDate
                : targetProgram.studentStatus.completionDate,
            graduationDate:
              status === ProgramStudentStatus.GRADUATED
                ? statusDate
                : targetProgram.studentStatus.graduationDate,
          };
        }

        // Update in programWithCourses array
        const targetProgramWithCourses = studentDetails.programWithCourses.find(
          (item) => item.id === programId && item.branchId === branchId,
        );

        if (targetProgramWithCourses) {
          targetProgramWithCourses.studentStatus = {
            ...targetProgramWithCourses.studentStatus,
            status: status,
            registrationDate:
              status === ProgramStudentStatus.REGISTERED
                ? statusDate
                : targetProgramWithCourses.studentStatus.registrationDate,
            studyingStartDate:
              status === ProgramStudentStatus.STUDYING
                ? statusDate
                : targetProgramWithCourses.studentStatus.studyingStartDate,
            cancellationDate:
              status === ProgramStudentStatus.CANCELLED
                ? statusDate
                : targetProgramWithCourses.studentStatus.cancellationDate,
            leftDate:
              status === ProgramStudentStatus.LEFT
                ? statusDate
                : targetProgramWithCourses.studentStatus.leftDate,
            completionDate:
              status === ProgramStudentStatus.COMPLETED
                ? statusDate
                : targetProgramWithCourses.studentStatus.completionDate,
            graduationDate:
              status === ProgramStudentStatus.GRADUATED
                ? statusDate
                : targetProgramWithCourses.studentStatus.graduationDate,
          };
        }

        // Force a state update by creating a new object with all the properties
        globalUserPage.studentDetails = {
          ...studentDetails,
          programs: [...studentDetails.programs],
          programWithCourses: [...studentDetails.programWithCourses],
          courses: [...studentDetails.courses],
          assignments: [...studentDetails.assignments],
          exams: [...studentDetails.exams],
          lectures: [...studentDetails.lectures],
          paymentServiceDetails: [...studentDetails.paymentServiceDetails],
          docs: [...studentDetails.docs],
        };
      });
    }

    setLoading(false);
    ohHide();
  } catch (e) {
    setLoading(false);
    toast.error('משהו קרה, נסה שוב בעוד מספר רגעים...');
    console.error(
      `updateStudentStatusInProgramOperation is failed with the programId: ${programId}, studentId: ${studentId}, status: ${status} with the error: ${e}`,
    );
  }
};
